import styled from 'styled-components';
import {
  COLORS,
  borderRadiusSm,
  paddingMd,
  paddingSm,
  paddingXs,
} from 'assets/styled';
import { HAS_IMAGES_BREAKPOINT } from 'utils/hooks/useHasImages';
import { respondTo } from 'assets/styled/breakpoints';

export const Wrapper = styled.div`
  min-height: 700rem;
  max-width: 100%;
  width: 100%;
  margin: 150rem 0 50rem;
  align-self: center;
  display: flex;
  flex-direction: column;
  gap: 20rem;

  ${respondTo.midTablet`
    margin-top: 80rem;
    margin-bottom: 150rem;
  `}

  ${respondTo.smallPhone`
    margin-bottom: 200rem;
  `}
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${paddingSm} 15rem;
  justify-content: space-between;
  background-color: ${COLORS.WHITE};
  border-radius: ${borderRadiusSm};
  width: 100%;

  ${respondTo.bigPhone`
    padding: 10rem;
  `};
  margin-bottom: 0rem;
  ${respondTo.smallTablet`
    margin-bottom: 15rem;
  `};
`;

export const ByCodeflexWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${paddingMd};
  padding-bottom: ${paddingXs};
`;

export const ByCodeflexText = styled.label`
  position: absolute;
  top: 40rem;
  font-weight: 400;
  font-size: 16rem;
  color: ${COLORS.BLACK};
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  // Display form images above the form questions when screen is small
  @media screen and (max-width: ${HAS_IMAGES_BREAKPOINT}px) {
    flex-direction: column;
    align-items: center;
  }
`;
